export function toggleStructureOverlayForNodeTap(event, $sbDetailsOverlay) {
    if (
        !event ||
        typeof event.structureId !== "string" ||
        event.structureId.length === 0
    ) {
        return;
    }

    $sbDetailsOverlay.toggleView("structure", event.structureId);
}
